import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Header.css';

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);


    useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, [loc.pathname]);
  const closeMenu = () => setMenuOpen(false);

  // const scrollToProducts = (e) => {
  //   e.preventDefault();
  //   closeMenu();
  //   if (loc.pathname !== '/') {
  //     window.location.href = '/#products';
  //   } else {
  //     document.getElementById('products')?.scrollIntoView({ behavior: 'smooth' });
  //   }
  // };

  return (
    <header className={`vts-header ${scrolled ? 'scrolled' : ''}`}>
      <div className="hdr-inner">
        {/* BRAND */}
        <Link to="/" className="brand" onClick={closeMenu}>
          <img src="/logo.png" alt="Vision Techno Services" className="brand-logo" />
          <div className="brand-text">
            <span className="brand-name">Vision Techno Services</span>
            <span className="brand-tag">AI-Powered Solutions</span>
          </div>
        </Link>

       

        {/* NAV */}
        <nav className={`hdr-nav ${menuOpen ? 'open' : ''}`}>
          <Link to="/" className={`nav-link ${loc.pathname === '/' ? 'active' : ''}`} onClick={closeMenu}>Home</Link>
          <Link to="/products" className={`nav-link ${loc.pathname === '/products' ? 'active' : ''}`} onClick={closeMenu}>Products</Link>
          <Link to="/contact" className={`nav-link nav-cta ${loc.pathname === '/contact' ? 'active' : ''}`} onClick={closeMenu}>Contact Us</Link>
        </nav>

        {/* HAMBURGER */}
        <button className={`hamburger ${menuOpen ? 'open' : ''}`} onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
          <span /><span /><span />
        </button>
      </div>
    </header>
  );
}
